import { render, staticRenderFns } from "./OwnerDashboard.vue?vue&type=template&id=71be9a8a&"
import script from "./OwnerDashboard.vue?vue&type=script&lang=js&"
export * from "./OwnerDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports